module.exports = __webpack_public_path__ + "static/img/icon10.ebbe1291.png";